import { render, staticRenderFns } from "./Like.vue?vue&type=template&id=9b56c32c&scoped=true&"
import script from "./Like.vue?vue&type=script&lang=ts&"
export * from "./Like.vue?vue&type=script&lang=ts&"
import style0 from "./Like.vue?vue&type=style&index=0&id=9b56c32c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b56c32c",
  null
  
)

export default component.exports